import { callProcedure } from 'clickNgo/helpers/api'

import { IMarketYoyGrowthExpectationApi } from './types'

export interface IApplyYoyGrowthPlanningDetailsChangesParams {
  planningEntryId: number
  payload: IMarketYoyGrowthExpectationApi[]
}

/**
 * Persists edited expectation records. The SP response shape is unconfirmed,
 * so success is treated as opaque — callers fold pending edits client-side.
 */
export const applyYoyGrowthPlanningDetailsChanges = async ({
  planningEntryId,
  payload,
}: IApplyYoyGrowthPlanningDetailsChangesParams): Promise<void> => {
  const response = await callProcedure({
    url: '/webservice/621/sp/v4/spJBPYoYGrowthPlanningDetailsApplyChanges/call',
    method: 'POST',
    data: {
      'p.PlanningEntryID': planningEntryId,
      'p.DataJSON': JSON.stringify(payload),
    },
  })

  if ('error' in response) {
    throw response.error
  }
}
